(() => {
  const initFooter = (section) => {
    if (!section || section.dataset.krsFooterInit === 'true') return;
    section.dataset.krsFooterInit = 'true';

    const enableAccordion = section.dataset.accordion === 'true';
    const keepAccordionOpen = section.dataset.accordionKeepOpen === 'true';
    const breakpoint = 990;
    const columns = Array.from(section.querySelectorAll('[data-krs-footer-column]'));
    const demoForms = Array.from(section.querySelectorAll('[data-demo-newsletter="true"]'));

    const expandLabel = section.dataset.accordionExpandLabel || '';
    const collapseLabel = section.dataset.accordionCollapseLabel || '';

    const updateNoTitleAria = (summary, isOpen) => {
      if (summary.dataset.noColumnTitle !== 'true') return;
      if (isOpen && collapseLabel) {
        summary.setAttribute('aria-label', collapseLabel);
      } else if (!isOpen && expandLabel) {
        summary.setAttribute('aria-label', expandLabel);
      }
    };

    const setColumnState = (column, isOpen) => {
      const summary = column.querySelector('.krs-re-footer__column-title');
      const content = column.querySelector('.krs-re-footer__column-content');
      if (!summary || !content) return;
      summary.setAttribute('aria-expanded', String(isOpen));
      column.classList.toggle('is-open', isOpen);
      updateNoTitleAria(summary, isOpen);
      if (isOpen) {
        column.setAttribute('open', 'open');
        content.removeAttribute('hidden');
      } else {
        column.removeAttribute('open');
        content.setAttribute('hidden', 'hidden');
      }
    };

    const setAccordionMode = (isMobile) => {
      columns.forEach((column) => {
        const summary = column.querySelector('.krs-re-footer__column-title');
        if (!summary) return;
        if (!enableAccordion || !isMobile || keepAccordionOpen) {
          summary.setAttribute('aria-expanded', 'true');
          summary.setAttribute('aria-disabled', 'true');
          setColumnState(column, true);
        } else {
          summary.setAttribute('aria-disabled', 'false');
          setColumnState(column, false);
        }
      });
    };

    const handleResize = () => {
      const isMobile = window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
      setAccordionMode(isMobile);
    };

    columns.forEach((column) => {
      const summary = column.querySelector('.krs-re-footer__column-title');
      if (!summary) return;
      summary.addEventListener('click', (event) => {
        const isMobile = window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
        if (!enableAccordion || !isMobile || keepAccordionOpen) {
          event.preventDefault();
          return;
        }
        const isOpen = summary.getAttribute('aria-expanded') === 'true';
        setColumnState(column, !isOpen);
        event.preventDefault();
      });
    });

    demoForms.forEach((form) => {
      const successMessage = form.closest('.krs-re-footer__newsletter')?.querySelector('[data-success-message]');
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (successMessage) {
          successMessage.classList.add('is-visible');
        }
        form.reset();
      });
    });

    handleResize();
    window.addEventListener('resize', handleResize);
  };

  document.querySelectorAll('.krs-re-footer').forEach(initFooter);

  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (!container) return;
    container.querySelectorAll('.krs-re-footer').forEach(initFooter);
  });
})();
